import { AnimatePresence, motion } from "framer-motion";

const QuizLayout = ({ leftContent, image }) => {
    return (
        <div className="quiz-container">

            {/* LEFT CONTENT */}
            <div className="quiz-left">
                {leftContent}
            </div>

            {/* RIGHT IMAGE */}
            <div className="quiz-right">

                <AnimatePresence mode="wait">

                    <motion.div
                        key={image}
                        initial={{
                            opacity: 0,
                            scale: 1.08
                        }}
                        animate={{
                            opacity: 1,
                            scale: 1
                        }}
                        exit={{
                            opacity: 0,
                            scale: 1.05
                        }}
                        transition={{
                            duration: 0.8,
                            ease: "easeInOut"
                        }}
                        className="quiz-image-wrapper"
                    >

                        <motion.img
                            src={image}
                            alt="quiz"
                            initial={{
                                scale: 1.15,
                                opacity: 0,
                                filter: "blur(12px)"
                            }}
                            animate={{
                                scale: 1,
                                opacity: 1,
                                filter: "blur(0px)"
                            }}
                            exit={{
                                scale: 1.08,
                                opacity: 0,
                                filter: "blur(12px)"
                            }}
                            transition={{
                                duration: 1,
                                ease: "easeInOut"
                            }}
                            className="quiz-side-image"
                        />

                        <div className="quiz-image-overlay"></div>

                    </motion.div>

                </AnimatePresence>

            </div>

        </div>
    );
};

export default QuizLayout;